export function FindMatchingParent(anObj, FieldDefArray, matchValue) {
  if (anObj == null) return false;
  for (var fieldIndex in FieldDefArray) {
    var thisField = FieldDefArray[fieldIndex];
    var newValue = anObj.GetFieldValue(thisField);
    var didMatch =
      newValue != null && matchValue != null
        ? anObj.GetFieldValue(thisField).toString().toLowerCase() ===
          matchValue.toString().toLowerCase()
        : false;
    if (didMatch) return true;
  }
  //wasn't a match? Keep looking upwards then.
  var parentObj = anObj.GetParent();
  return parentObj != null ? FindMatchingParent(parentObj, FieldDefArray, matchValue) : false;
}
